import api from "./axiosConfig";
import { hashPassword } from "./api";

// (2026-05-13) Todas las contraseñas se envían como SHA-256 hex.
// El backend (AUTH_HASH_MODE='sha256') valida el formato y bcrypt-encripta encima.

// Login
// (2026-05-20) Single-session option #2: el backend devuelve 409
// {codigo: "sesion_activa", permite_forzar: true, ...} cuando hay una sesion
// activa para este usuario. Si force=true, el backend sobrescribe la sesion
// anterior y emite un token nuevo (la sesion vieja queda invalidada via
// blocklist en el siguiente request).
export const loginRequest = async (email, password, { force = false } = {}) => {
  const body = {
    email,
    password: hashPassword(password),
  };
  if (force) {
    body.force = true;
  }
  const response = await api.post("/api/login", body);
  return response.data; // devuelve { mensaje, token, usuario, expires_in }
};

// (2026-05-20) Logout explicito: limpia usuarios.current_jti server-side.
// Es best-effort: si falla la red o el token ya esta invalido, no aborta el
// logout del frontend (el caller debe igualmente descartar el token local).
export const logoutRequest = async () => {
  try {
    const response = await api.post("/api/logout");
    return response.data;
  } catch (e) {
    // No re-lanzar: el frontend descarta su estado de igual modo.
    return null;
  }
};

export const forgotPassword = async (email) => {
  const response = await api.post("/api/forgot-password", {
    email,
  });
  return response.data;
};

export const resetPassword = async (token, newPassword) => {
  const response = await api.post("/api/reset-password", {
    token,
    new_password: hashPassword(newPassword),
  });
  return response.data;
};

export const apiRegister = async (body) => {
  const payload = { ...body };
  if (payload.password) {
    payload.password = hashPassword(payload.password);
  }
  const response = await api.post(" /api/register", payload);
  return response.data;
};
